module.exports = __webpack_public_path__ + "static/media/mem5YaGs126MiZpBA-UNirkOUehpOqc.faf40e5a.woff2";